import { HomeWrap } from "./HomeWrap";
import liveConditions from "@/assets/home-live-conditions.jpg";

export function HomeLiveConditions() {
  return (
    <section className="py-[88px] max-[820px]:py-[60px]">
      <HomeWrap className="grid items-center gap-10 min-[900px]:grid-cols-[1.05fr_.95fr] min-[900px]:gap-[72px]">
        <div className="rounded-[20px] border border-[#E2D5C0] bg-[#F2EADC] p-[26px]">
          <div className="overflow-hidden rounded-xl border border-[#E4D8C6] shadow-[0_30px_60px_-40px_rgba(28,19,12,.5)]">
            <img
              src={liveConditions}
              alt="Live conditions in Grounded showing WiFi speed, noise level, crowd and outlets."
              loading="lazy"
              width={880}
              height={402}
              className="block w-full"
            />
          </div>
        </div>
        <div>
          <span className="mb-[18px] inline-flex items-center gap-2 rounded-full bg-[rgba(74,124,89,.1)] px-[13px] py-1.5 text-[13px] font-semibold tracking-[.02em] text-[#4A7C59]">
            <span aria-hidden="true" className="h-[7px] w-[7px] rounded-full bg-[#4A7C59]" />
            From check ins
          </span>
          <h2 className="font-display text-[clamp(30px,3.6vw,40px)] font-semibold leading-[1.08] tracking-[-0.015em] text-[#3B2314]">
            What the last person in there saw
          </h2>
          <p className="mt-5 max-w-[46ch] text-[17.5px] leading-[1.6] text-[#7B4F2E]">
            The score tells you what a café is set up for. The people working in it today tell you
            how fast the WiFi actually is, how busy it is, how loud, and whether the outlets are
            taken.
          </p>
        </div>
      </HomeWrap>
    </section>
  );
}
